<template>
    <div id="page">

        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>یادآورها و وظایف دوره ای
                    <button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="" data-card-height="150" style="-webkit-transform: translate3d(0, 0, 0); background-size: cover; border: 0px !important; max-height: 150000px; margin-bottom: 30px; background-position: center center !important; z-index: -1; top: 0px; position: absolute; left: -8px; right: -8px; overflow: hidden; border-bottom-left-radius: 45px; border-bottom-right-radius: 45px;">
                <div style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1; opacity: 0.95; background-color: #4a89dc !important;"></div>
                <div class="dark-mode-tint" style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1;"></div>
                <div style="background-image: url(/assets/Images/pictures/20.jpg); background-position: center center; background-repeat: no-repeat; position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; background-size: cover; z-index: 0;"></div>
            </div>

            <span data-menu="menu-language" class="optionMenu"></span>


            <div v-if="true">
                <div class="card card-style mb-2" v-for="task in ReminderList" :key="task.reminderId" @click.prevent="openDetails(task.reminderId)">
                    <div class="list-group list-custom-small list-icon-0">
                        <div class="list-group-div p-2">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <i class="fa fa-calendar text-warning"></i>
                                    <span class="text-muted ltr float-left">{{task.createDateTime}}</span>
                                </div>
                                <div>
                                    <i v-if="task.taskId==null" class="fa fa-bell color-green2-dark"></i>
                                    <i v-else class="fa fa-tasks color-green2-dark"></i>
                                    <span v-if="task.taskId==null" class="text-muted text-left ltr">یادآور</span>
                                    <span v-else class="text-muted text-left ltr">وظیفه دوره ای</span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div>
                                    <i class="fa fa-check color-red1-dark"></i>
                                    <span class="font-weight-bold">{{task.title}}</span>
                                </div>
                                <span @click.stop="showMenu(task.reminderId)" width="60px"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card card-style" v-if="Loading">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100 py-5">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                </div>
                <div class="card card-style" v-if="ReminderList.length==0 && Loading==false">
                    <div class="content">
                        <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                        <p class="text-center py-3">یادآوری یافت نشد.</p>
                    </div>
                </div>
            </div>

            <div class="card card-style" v-else>
                <div class="content">
                    <h4 class="mb-0 text-center">تصاویر بخش یادآورها</h4>
                </div>
                <div class="divider mb-0"></div>
                <div class="gallery-view-controls d-flex justify-content-center">
                    <a href="#" class="gallery-view-1-activate"><i class="fa fa-th"></i></a>
                    <a href="#" class="gallery-view-2-activate color-highlight"><i class="fa fa-th-large"></i></a>
                    <div class="clearfix"></div>
                </div>
                <div class="content my-n1">
                    <div class="gallery-views gallery-view-2">
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/reminder-1-L.jpg" title="لیست یادآورها و وظایف دوره ای" class="default-link">
                            <img src="/assets/images/gallery/reminder-1-500x500.jpg" data-src="/assets/images/gallery/reminder-1-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">لیست یادآورها و وظایف دوره ای</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/reminder-2-L.jpg" title="ثبت یادآور" class="default-link">
                            <img src="/assets/images/gallery/reminder-2-500x500.jpg" data-src="/assets/images/gallery/reminder-2-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">ثبت یادآور</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/reminder-3-L.jpg" title="انتخاب نوع تکرار یادآور" class="default-link">
                            <img src="/assets/images/gallery/reminder-3-500x500.jpg" data-src="/assets/images/gallery/reminder-3-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">انتخاب نوع تکرار یادآور</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/reminder-4-L.jpg" title="مشاهده جزئیات تاریخ ارسال یادآور" class="default-link">
                            <img src="/assets/images/gallery/reminder-4-500x500.jpg" data-src="/assets/images/gallery/reminder-4-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">مشاهده جزئیات تاریخ ارسال یادآور</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                    </div>
                </div>

                <a href="/order" class="btn btn-l btn-icon bg-green2-dark rounded-s shadow-s btn-full btn-margins font-900 text-uppercase text-left mt-3"><i class="fa fa-credit-card text-center"></i>تهیه اشتراک اپلیکشن</a>
            </div>

        </div>

        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn" v-if="isFreeRegist!==true" :style="{top:addButtonTop}">
                <router-link to="/CreateReminder" class="btn px-3 py-2 rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
                    <i class="fa fa-plus font-14"></i>
                </router-link>
            </div>
        </transition>

        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'EditReminder', params: { reminderId: selectedReminderId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <button @click="deleteReminder" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Help-Menu title="راهنمای ثبت یادآور" keyEn="TaskList"></Help-Menu>

        <!--<div id="createReminderHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">راهنمای ثبت یادآور</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-Reminder.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-Reminder.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-1" class="collapsed list-group-div" aria-expanded="false">
                                <i class="far font-14 fa-check-circle color-red2-dark"></i>
                                <span class="font-14">راهنمای ثبت یادآور</span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-1" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video1" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-riminder.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-riminder.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
    </div>



</template>

<script>
    import VueSimpleAlert from "vue3-simple-alert";
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedReminderId: 0,
                pageLoaded: false
            };
        },
        computed: {
            ReminderList() {
                return this.$store.getters.GetReminderList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetReminderNoMoreData;
            },
            isFreeRegist() {
                return this.$store.getters.GetIsFreeRegist;
            },
            UpdateReminderList() {
                return this.$store.getters.GetUpdateReminderList;
            },
        },

        created() {
            console.log(this.NoMoreData);
            this.$store.dispatch("GetReminderListFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey
            });
        },
        methods: {
            showAddButton() {
                this.pageLoaded = true;

            },
            showMenu(reminderId) {
                this.selectedReminderId = reminderId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetReminderListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            openDetails(reminderId) {
                this.$router.push({ name: 'EditReminder', params: { reminderId: reminderId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            deleteReminder() {
                document.getElementsByClassName('menu-hider')[0].click();
                VueSimpleAlert.confirm("آیا مایل به حذف این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("Reminder/Delete?id=" + this.selectedReminderId)
                        .then(data => {
                            var res = data.data.toString();
                            if (res === "1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.filterList();

                            }
                            else {
                                this.showErrorMessage(res);
                            }


                        });
                });
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },

        },
        mounted() {
            console.log("mounted");
            this.showAddButton();
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },
        activated() {
            console.log("mounted");
            this.showAddButton();
            if (this.UpdateReminderList == true) {
                this.page = 1;
                this.filterList();
            }
            // this.getNextPageForReminderList();
        },
    };
</script>
